export const SET_FIRE_PANEL_STATUS = 'SET_FIRE_PANEL_STATUS';
export const SET_FIRE_PANEL_LIST = 'SET_FIRE_PANEL_LIST';
